import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import Selector from "../../../../../../atoms/ActiveLearning/Selector";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconAdd } from "../../../../../../assets/images/ActiveLearning/icon_add.svg";
import hintImage21 from "../../../../../../assets/images/ActiveLearning/hint/img_21.webp";

type Issue3MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue3Material = (props: Issue3MaterialProps) => {
  const question1 = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 1);
    if (q) return q;
  }, [props.issue]);

  const question2 = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 2);
    if (q) return q;
  }, [props.issue]);

  const question3 = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 3);
    if (q) return q;
  }, [props.issue]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          社会で行われている課題解決も、もとは小さな「もっと〇〇」から生まれている。これまでのLessonで自分が考えた課題解決のアイデアを社会で実現できるとしたら、どのような仕事が関係するかを考えて入力しよう。
        </p>
      </div>
      <img src={hintImage21} alt="関係する仕事を考えるヒント" />
      {question1 && (
        <div className={clsx(styles.question, styles.primary)}>
          <div className={styles.itemAddition}>
            <ul className={styles.listItem}>
              <li className={styles.item}>
                <TextInput />
              </li>
              <li className={styles.item}>
                <TextInput />
              </li>
              <li className={styles.item}>
                <TextInput />
              </li>
            </ul>
            <div className={styles.buttonWrapper}>
              <Button width={"150px"} height={"37px"} fontSize={"14px"}>
                <IconAdd />
                項目を追加する
              </Button>
            </div>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>{question2?.title}</p>
            <div className={styles.textAreaWrapper}>
              <Selector />
            </div>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>{question3?.title}</p>
            <div className={styles.textAreaWrapper}>
              <TextArea />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue3Material;
